import * as React from "react";
import { cn } from "../../lib/utils";
import { iconVariants } from "./icon-variants";
import { IconProps } from "./icon-types";

const Icon = React.forwardRef<HTMLSpanElement, IconProps>(
  (
    {
      className,
      size,
      color,
      children,
      icon: IconComponent,
      iconProps = {},
      ...props
    },
    ref
  ) => {
    const iconClasses = cn(iconVariants({ size, color }), className);

    if (IconComponent) {
      const IconComp = IconComponent as React.ComponentType<{ className?: string }>;
      return (
        <span className={iconClasses} ref={ref} {...props}>
          <IconComp
            className={cn("w-full h-full", iconProps.className)}
            {...iconProps}
          />
        </span>
      );
    }

    if (children) {
      if (React.isValidElement(children)) {
        const childElement = children as React.ReactElement<any>;
        return (
          <span className={iconClasses} ref={ref} {...props}>
            {React.cloneElement(childElement, {
              ...childElement.props,
              className: cn("w-full h-full", childElement.props.className),
            })}
          </span>
        );
      }

      return (
        <span className={iconClasses} ref={ref} {...props}>
          {children}
        </span>
      );
    }

    return <span className={iconClasses} ref={ref} {...props} />;
  }
);

Icon.displayName = "Icon";

export { Icon };
